/**
 * Is the dashboard itself online (BA-85 S8, C5b): Firebase's .info/connected, and the
 * browser's online/offline events
 */

import { useEffect, useState } from 'react';
import { ref, onValue } from 'firebase/database';
import { database } from '../firebase';

export function useOnline(): boolean {
  const [browserOnline, setBrowserOnline] = useState(
    () => typeof navigator === 'undefined' || navigator.onLine !== false
  );
  // Unknown until Firebase says: a dashboard that is still connecting is not "offline"
  const [connected, setConnected] = useState<boolean | null>(null);

  useEffect(() => {
    const on = () => setBrowserOnline(true);
    const off = () => setBrowserOnline(false);
    window.addEventListener('online', on);
    window.addEventListener('offline', off);
    return () => {
      window.removeEventListener('online', on);
      window.removeEventListener('offline', off);
    };
  }, []);

  useEffect(() => {
    let seenTrue = false;
    const unsubscribe = onValue(ref(database, '.info/connected'), (snapshot) => {
      // .info/connected starts false before the first connection: only a drop counts
      if (snapshot.val() === true) {
        seenTrue = true;
        setConnected(true);
      } else {
        setConnected(seenTrue ? false : null);
      }
    });
    return () => unsubscribe();
  }, []);

  return browserOnline && connected !== false;
}
